(function () {
  var GRID_SELECTOR = '.CartEmptyRecommendations__Grid[data-empty-cart-prioritize-recently="true"]';
  var stateByGrid = new WeakMap();

  function log(message, payload) {
    if (payload !== undefined) {
      console.log('[CartEmptyRVP] ' + message, payload);
    } else {
      console.log('[CartEmptyRVP] ' + message);
    }
  }

  function getRecentlyViewedIds() {
    try {
      var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function hasRecentNodes(grid) {
    return !!grid.querySelector('.CartEmptyRecoCell--recently-viewed');
  }

  function ensureState(grid) {
    var state = stateByGrid.get(grid);

    if (!state) {
      state = {
        cachedNodes: null,
        applying: false,
        observer: null,
        reapplyTimer: null,
        fetchSignature: null
      };
      stateByGrid.set(grid, state);
    }

    return state;
  }

  function applyNodes(grid, nodes, source) {
    if (!nodes || nodes.length === 0) return false;

    var state = ensureState(grid);
    state.applying = true;
    grid.innerHTML = '';

    for (var i = 0; i < nodes.length; i++) {
      grid.appendChild(nodes[i].cloneNode(true));
    }

    grid.setAttribute('data-empty-cart-reco-source', source);
    grid.setAttribute('data-empty-cart-reco-rvp-cells', String(nodes.length));
    grid.style.opacity = '1';
    state.applying = false;
    return true;
  }

  function fetchRecentlyViewedNodes(grid) {
    var maxItems = parseInt(grid.getAttribute('data-empty-cart-reco-max') || '8', 10);
    var sectionId = grid.getAttribute('data-empty-cart-rvp-section-id') || 'recently-viewed-products';
    var items = getRecentlyViewedIds().slice(0, maxItems);

    if (items.length === 0) {
      grid.setAttribute('data-empty-cart-reco-source', 'recently-viewed-empty-localstorage');
      return Promise.resolve(null);
    }

    var state = ensureState(grid);
    var signature = items.join(',') + '|' + maxItems + '|' + sectionId;

    if (state.cachedNodes && state.fetchSignature === signature) {
      return Promise.resolve(state.cachedNodes.map(function (node) {
        return node.cloneNode(true);
      }));
    }

    var queryString = items.map(function (item) {
      return 'id:' + item;
    }).join(' OR ');

    var searchUrl = (window.routes && window.routes.searchUrl) ? window.routes.searchUrl : '/search';
    var fetchUrl = searchUrl + '?section_id=' + sectionId + '&type=product&q=' + encodeURIComponent(queryString);

    grid.setAttribute('data-empty-cart-reco-source', 'recently-viewed-fetching');
    grid.setAttribute('data-empty-cart-reco-rvp-count', String(items.length));
    log('fetch start', { fetchUrl: fetchUrl, count: items.length });

    return fetch(fetchUrl, { credentials: 'same-origin', method: 'GET' })
      .then(function (response) { return response.text(); })
      .then(function (content) {
        var temp = document.createElement('div');
        temp.innerHTML = content;

        var section = temp.querySelector('[data-section-type="recently-viewed-products"]');
        if (!section) {
          grid.setAttribute('data-empty-cart-reco-source', 'recently-viewed-no-section');
          log('section not found');
          return null;
        }

        var container = section.querySelector('.recently-viewed');
        if (!container) {
          grid.setAttribute('data-empty-cart-reco-source', 'recently-viewed-no-container');
          log('container not found');
          return null;
        }

        var cells = Array.prototype.slice.call(
          container.querySelectorAll('.Carousel__Cell'),
          0,
          maxItems
        );

        if (!cells.length) {
          grid.setAttribute('data-empty-cart-reco-source', 'recently-viewed-no-cells');
          log('no cells found');
          return null;
        }

        state.cachedNodes = cells.map(function (cell) {
          var recentNode = cell.cloneNode(true);
          recentNode.classList.add('CartEmptyRecoCell--recently-viewed');
          return recentNode;
        });
        state.fetchSignature = signature;

        return state.cachedNodes.map(function (node) {
          return node.cloneNode(true);
        });
      })
      .catch(function (error) {
        grid.setAttribute('data-empty-cart-reco-source', 'recently-viewed-fetch-error');
        log('fetch error', error);
        return null;
      });
  }

  function renderGrid(grid, reason) {
    if (!grid || grid.getAttribute('data-empty-cart-prioritize-recently') !== 'true') return;

    var state = ensureState(grid);
    if (state.applying) return;

    fetchRecentlyViewedNodes(grid).then(function (nodes) {
      if (!nodes || nodes.length === 0) return;
      applyNodes(grid, nodes, 'recently-viewed');
      log('rendered', { reason: reason, rendered: nodes.length });
    });
  }

  function watchGrid(grid) {
    var state = ensureState(grid);
    if (state.observer) return;

    state.observer = new MutationObserver(function () {
      if (state.applying) return;
      if (hasRecentNodes(grid)) return;
      if (!state.cachedNodes || state.cachedNodes.length === 0) return;

      if (state.reapplyTimer) {
        clearTimeout(state.reapplyTimer);
      }

      state.reapplyTimer = setTimeout(function () {
        if (state.applying) return;
        if (hasRecentNodes(grid)) return;

        if (applyNodes(grid, state.cachedNodes, 'recently-viewed-cached')) {
          log('re-applied cached nodes after mutation');
        }
      }, 80);
    });

    state.observer.observe(grid, { childList: true, subtree: true });
  }

  function initGrid(grid) {
    if (!grid || grid.getAttribute('data-empty-cart-prioritize-recently') !== 'true') return;

    watchGrid(grid);
    if (hasRecentNodes(grid)) return;
    renderGrid(grid, 'init');
  }

  function scan() {
    var grids = document.querySelectorAll(GRID_SELECTOR);
    for (var i = 0; i < grids.length; i++) {
      initGrid(grids[i]);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan();
  });

  document.documentElement.addEventListener('cart:refresh', function () {
    setTimeout(scan, 50);
    setTimeout(scan, 400);
    setTimeout(scan, 1200);
  });

  window.addEventListener('load', function () {
    scan();
  });
})();
